<!-- 文档审阅时限 -->
<template>
  <v-card :elevation="0" style="padding: 20px; border-radius: 4px">
    <div class="flex-y-center px-4 pb-2">
      <span class="flex-0 flex-shrink-0">文档审阅时限：</span>
      <form-item
        v-model="deadline"
        type="text"
        class="flex-0 flex-shrink-0"
        style="width: 150px"
        dense
      />
    </div>
    <div style="color: orange; margin-left: 10px">
      注：若为空，所有文档审核将不进行超时统计。
    </div>
    <div class="mt-5 pl-5">
      <v-btn
        small
        color="primary"
        depressed
        min-width="80"
        class="mr-2"
        height="30"
        style="padding: 0 8px"
        @click="save"
        >保存</v-btn
      >
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'ExamineDeadline',
  data() {
    return {
      deadline: '',
    };
  },
  methods: {
    save() {
      this.$http
        .post(this.$api.setFileExamineDeadline, {
          data: { value: this.deadline },
        })
        .then(() => {
          this.$message.success('保存成功');
        });
    },
  },
  mounted() {
    this.$http.post(this.$api.getFileExamineDeadline).then((res) => {
      this.deadline = res.result.SYSTEM_FILE_AUDIT_TIME;
    });
  },
};
</script>

<style lang="" scoped></style>
